import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

export default function AdminProfilePage() {
  const { user } = useContext(AuthContext);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #F8F6F2 0%, #FBFAF8 100%)",
        padding: "40px 16px",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      {/* HERO HEADER */}
      <div
        style={{
          maxWidth: 1000,
          margin: "0 auto 24px",
          padding: "32px",
          borderRadius: 20,
          background: "linear-gradient(135deg, #111827, #1f2937)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0 12px 32px rgba(0,0,0,0.05)",
        }}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: 28 }}>
             Admin Dashboard
          </h1>
          <p style={{ margin: "8px 0 0", color: "#cbd5e1" }}>
            Manage your store, products, and customer experience
          </p>
        </div>

        <div
          style={{
            padding: "8px 14px",
            borderRadius: 999,
            background: "rgba(255,255,255,0.1)",
            border: "1px solid rgba(255,255,255,0.2)",
            fontSize: 13,
          }}
        >
          SYSTEM ADMIN
        </div>
      </div>

      {/* MAIN GRID */}
      <div
        style={{
          maxWidth: 1000,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "320px 1fr",
          gap: 24,
        }}
      >
        {/* LEFT PANEL */}
        <div
          style={{
            background: "#fff",
            borderRadius: 20,
            padding: 24,
            border: "1px solid rgba(0,0,0,0.06)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.05)",
            textAlign: "center",
          }}
        >
          {/* Avatar */}
          <div
            style={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              margin: "0 auto 16px",
              background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 28,
              fontWeight: "bold",
            }}
          >
            {(user?.first_name?.[0] || "A")}
            {(user?.last_name?.[0] || "")}
          </div>

          <h2 style={{ margin: 0 }}>
            {user?.first_name || "Admin"} {user?.last_name || ""}
          </h2>

          <p style={{ color: "#6b7280", marginTop: 6 }}>
            {user?.email || "admin@store.com"}
          </p>

          <div
            style={{
              marginTop: 12,
              display: "inline-block",
              padding: "6px 12px",
              borderRadius: 999,
              background: "#111827",
              color: "#fff",
              fontSize: 12,
              letterSpacing: 1,
            }}
          >
            ADMINISTRATOR
          </div>

          {/* Stats */}
          <div
            style={{
              marginTop: 24,
              display: "grid",
              gap: 12,
              textAlign: "left",
            }}
          >
            {statBox("Access Level", "Full Control")}
            {statBox("Security", "2FA Enabled")}
            {statBox("Status", "Active", "#16a34a")}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div
          style={{
            background: "#fff",
            borderRadius: 20,
            padding: 28,
            border: "1px solid rgba(0,0,0,0.06)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.05)",
          }}
        >
          <h3 style={{ marginTop: 0 }}>Account Details</h3>

          {detailRow("First Name", user?.first_name)}
          {detailRow("Last Name", user?.last_name)}
          {detailRow("Email Address", user?.email)}
          {detailRow("Role", "Administrator")}
          {detailRow("Member Since", "2026")}

          <div
            style={{
              marginTop: 30,
              display: "flex",
              gap: 12,
            }}
          >
            <button style={primaryBtn()}>Edit Profile</button>
            <button style={secondaryBtn()}>Security Settings</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* FIXED HELPERS */

function statBox(label, value, valueColor = "#111") {
  return (
    <div
      style={{
        padding: 12,
        borderRadius: 12,
        border: "1px solid rgba(0,0,0,0.06)",
        background: "#FBFAF8",
        display: "flex",
        justifyContent: "space-between",
        fontSize: 13,
      }}
    >
      <span style={{ color: "#6b7280" }}>{label}</span>
      <strong style={{ color: valueColor }}>{value}</strong>
    </div>
  );
}

function detailRow(label, value) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 0",
        borderBottom: "1px solid rgba(0,0,0,0.06)",
      }}
    >
      <span style={{ color: "#6b7280" }}>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );
}

function primaryBtn() {
  return {
    padding: "10px 16px",
    borderRadius: 10,
    border: "none",
    background: "#111827",
    color: "#fff",
    cursor: "pointer",
    fontWeight: 600,
  };
}

function secondaryBtn() {
  return {
    padding: "10px 16px",
    borderRadius: 10,
    border: "1px solid rgba(0,0,0,0.06)",
    background: "#fff",
    cursor: "pointer",
    fontWeight: 600,
  };
}
